import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=0dbcb9fa&"
import script from "./Container.vue?vue&type=script&lang=js&"
export * from "./Container.vue?vue&type=script&lang=js&"
import style0 from "./Container.vue?vue&type=style&index=0&id=0dbcb9fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports